import React, { useState } from 'react';
import VocabularyTermsView from './VocabularyTermsView';
import TaxonomyCleanupView from './TaxonomyCleanupView';


export default function TaxonomyView({ onOpenPlace }) {
  const [activeTab, setActiveTab] = useState('terms');

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-gray-900">Taxonomy</h1>
        <div className="mt-3 flex gap-5 border-b border-gray-200" role="tablist" aria-label="Taxonomy views">
          {[
            ['terms', 'Terms'],
            ['review', 'Librarian Review'],
          ].map(([id, label]) => (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={activeTab === id}
              onClick={() => setActiveTab(id)}
              className={`border-b-2 px-1 pb-2 text-sm font-medium ${
                activeTab === id
                  ? 'border-blue-600 text-blue-700'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-800'
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {activeTab === 'terms' ? (
        <VocabularyTermsView embedded />
      ) : (
        <TaxonomyCleanupView onOpenPlace={onOpenPlace} />
      )}
    </div>
  );
}
